import { styled, Grid as BaseGrid } from '@mui/material'

export const Row = styled(BaseGrid)`
  display: flex;
  justify-content: center;
  padding: 150px 0 0;
`
